import { inject } from '@angular/core';
import { ActivatedRoute, CanActivateFn, Router } from '@angular/router';

import { IdentityCommonService } from '@auth';
import { ErrorService } from '@services';

export const errorGuard: CanActivateFn = (route, state) => {
    const errorService = inject(ErrorService);
    const router = inject(Router)
    const activatedRoute = inject(ActivatedRoute);
    const identityCommonService = inject(IdentityCommonService);

    if (errorService.hasError()) {
        return true
    }

    router.navigate([identityCommonService.getLandingPath()], { relativeTo: activatedRoute.parent });
    return false;
};
